import React from "react";

const LoadingSuccessErrorAlertRerun = ({ loading, handle_reload }) => {
  if(!["Saving", "Error", "Success"].includes(loading.status)) return <></>

  return (
    <div className=" ps-4 pe-5">
      {loading.status === "Saving" && (
        <div className="alert alert-primary bg-white small p-2" role="alert">
          <span className="fas fa-circle-notch fa-spin" />
          &nbsp;
          <strong>{loading.message}</strong>
        </div>
      )}

      {loading.status === "Error" && (
        <div className="alert alert-danger bg-white small p-2" role="alert">
          <span className="fas fa-exclamation-triangle" />
          &nbsp;
          <strong>
            {loading.message} &nbsp;
            <button data-testid="common-loadingsuccesserroralertrerun-button-1"
              className="btn btn-info bg-white btn-sm small p-0"
              onClick={handle_reload}
            >
              Retry
            </button>
          </strong>
        </div>
      )}
      {loading.status === "Success" && loading.message !== undefined && (
        <div className="alert alert-primary bg-white small p-2" role="alert">
          <span className="far fa-check-circle" />
          &nbsp;
          <strong>{loading.message}</strong>
        </div>
      )}
    </div>
  );
};
export default LoadingSuccessErrorAlertRerun;
